import * as Sentry from '@sentry/browser'

export default () => {
  const snackbar = useSnackbar()

  // eslint-disable-next-line require-await
  const getEffectiveAuthToken = async (): Promise<string | null> => {
    // Keep this function async in case we need to fetch the token API from an auth library in the future (e.g. Clerk)
    try {
      const legacyToken = localStorage.getItem('auth-token')
      if (legacyToken) {
        return `JWT ${legacyToken}`
      }
      return null
    } catch (error) {
      Sentry.captureException(error)
      snackbar.error('Authentication token unavailable. Please refresh and try again.')
      return null
    }
  }

  const getEffectiveAuthTokenRaw = async (): Promise<string | null> => {
    const token = await getEffectiveAuthToken()
    if (token) {
      return token.split(' ')[1]
    }
    return null
  }

  return {
    getEffectiveAuthToken,
    getEffectiveAuthTokenRaw
  }
}
